import { c as _c } from "react/compiler-runtime";
import { BadRequest } from '@systemeio/util';
import { updateUserPlan } from 'modules/profile/user-plan/api/user-plan-api';
import StripeWrapper from 'modules/profile/user-plan/components/price-plan-columns/components/stripe-wrapper';
import UpgradePlanConfirmationModal from 'modules/profile/user-plan/components/price-plan-columns/components/upgrade-plan-confirmation-modal';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { useStripeUserPlanConfirmation } from 'modules/profile/user-plan/hooks/use-stripe-user-plan-confirmation';
import { useUserPlan } from 'modules/profile/user-plan/hooks/use-user-plan';
import { UserPlanInterface, UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { useState } from 'react';
import { toast } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export interface StripeUpgradePlanModalProps {
  pricePlan: UserPlanInterface;
  billingPeriod: BillingPeriodEnum;
  paymentPageUrl: string;
  cost: string;
  paymentMethod?: UseUserPlanInterface['customer']['paymentMethod'];
  isPlanUpgradeAvailable?: boolean;
}
const StripeUpgradePlanModalContent = ({
  pricePlan,
  billingPeriod,
  paymentPageUrl,
  cost,
  paymentMethod,
  isPlanUpgradeAvailable
}: StripeUpgradePlanModalProps) => {
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState('');
  const {
    mutate
  } = useUserPlan();
  const {
    confirmIntent
  } = useStripeUserPlanConfirmation(paymentMethod);
  const onConfirm = async () => {
    setError('');
    setIsFetching(true);
    try {
      const response = await updateUserPlan({
        userPlan: pricePlan.id,
        period: billingPeriod
      });
      if (response.data.redirect) {
        window.location.assign(response.data.redirect);
        return;
      }
      if (response.data.intentClientSecret) {
        const {
          error: confirmError
        } = await confirmIntent(response.data.intentClientSecret);
        if (confirmError) {
          setError(confirmError);
          return;
        }
      }
      await mutate();
      toast.success(t('dashboard.settings.user_plan.upgrade_success_title'));
      setOpened(false);
    } catch (e) {
      if (e instanceof BadRequest && e.errors.common) {
        setError(e.errors.common.join(''));
      } else {
        setError(t('core.error.internal_error_message'));
      }
    } finally {
      setIsFetching(false);
    }
  };
  return <UpgradePlanConfirmationModal pricePlan={pricePlan} paymentPageUrl={paymentPageUrl} cost={cost} isPlanUpgradeAvailable={isPlanUpgradeAvailable} opened={opened} onOpen={() => setOpened(true)} onClose={() => setOpened(false)} afterModalClose={() => setError('')} isFetching={isFetching} error={error} onConfirm={onConfirm} />;
};
const StripeUpgradePlanModal = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <StripeWrapper><StripeUpgradePlanModalContent {...props} /></StripeWrapper>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export default StripeUpgradePlanModal;